export const SESSION_STORAGE_KEYS = {
  COOKIE_ALERT: 'CookieAlert',
  FORGOT_PASSWORD_USER_ID: 'ForgotPassword:UserId',
};

export const DEFAULT_EMAIL_ID = '__defaultEmail__';

export const colors = ['#1C2526', '#1D3557', '#1A535C', '#2E6F47', '#F48C06', '#9D2A2A', '#5E2E8F', '#6B7280', '#457B9D', '#4D908E', '#52A776', '#F4A261', '#E63946', '#8E44AD'];

export const PREFIXES = ['Mr', 'Mrs', 'Ms', 'Miss', 'Dr', 'Prof'];

export const SUFFIXES = ['Jr', 'Sr', 'II', 'III', 'IV', 'V', 'MD', 'PhD', 'Esq'];

export const INT32_MIN = -2147483648;
export const INT32_MAX = 2147483647;
